import { SetNewPrimaryAddressResponse } from 'api/evisaAPI/evisaAPI'
import { CallAPIAction, Status } from 'api/types'
import { NationalAddressType } from 'common/utils/auth/authManager'
import { nationalAddressConvert } from 'common/utils/convertResponse/convertUserProfileResponse'
import Actions from 'redux/actions'

type State = {
  addresses: Array<NationalAddressType>
} & Status

const initialState: State = {
  addresses: [],
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SET_NEW_PRIMARY_ADDRESS_ASYNC,
    Actions.SET_NEW_PRIMARY_ADDRESS_SUCCESS,
    Actions.SET_NEW_PRIMARY_ADDRESS_FAIL,
    SetNewPrimaryAddressResponse
  >,
) => {
  switch (action.type) {
    case Actions.SET_NEW_PRIMARY_ADDRESS_SUCCESS: {
      return {
        ...state,
        ...action.status,
        addresses: action.payload.detailed_address.map(nationalAddressConvert),
      }
    }

    case Actions.SET_NEW_PRIMARY_ADDRESS_ASYNC:
    case Actions.SET_NEW_PRIMARY_ADDRESS_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
